var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerPreview(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 123,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .291)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.41 2.5h45.18c2.087 0 2.851.2 3.616.609a4.05 4.05 0 011.685 1.685c.41.765.609 1.529.609 3.616h0v107.18c0 2.087-.2 2.851-.609 3.616a4.05 4.05 0 01-1.685 1.685c-.765.41-1.529.609-3.616.609h0H6.41c-2.087 0-2.851-.2-3.616-.609a4.05 4.05 0 01-1.685-1.685c-.41-.765-.609-1.529-.609-3.616h0V8.41c0-2.087.2-2.851.609-3.616a4.05 4.05 0 011.685-1.685c.765-.41 1.529-.609 3.616-.609h0z",
    stroke: "#CCC",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("text", {
    fontSize: 8,
    fill: "#454B56"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 14,
    y: 118
  }, "Preview")), /*#__PURE__*/React.createElement("rect", {
    fill: "#DDD",
    opacity: 0.3,
    x: 2.694,
    y: 17.137,
    width: 53.388,
    height: 32.327,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#777",
    opacity: 0.3,
    d: "M1 14.709h56v14.694H1z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    fill: "#D8D8D8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.694 71.75h53.388v1H2.694zM2.694 74.199h36v1h-36z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    fill: "#D8D8D8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.694 76.647H45.55v1H2.694zM2.694 79.096h26.694v1H2.694z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    fill: "#D8D8D8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.694 102.852h22.53v1H2.695zM2.694 105.3h15.184v1H2.694z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    fill: "#D8D8D8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.327 102.852h22.53v1h-22.53zM32.327 105.3H47.51v1H32.327z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#DDD",
    opacity: 0.5,
    strokeLinecap: "square",
    d: "M57 83.265H1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#CCC",
    strokeLinecap: "square",
    d: "M56.767 109.714H1.233"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DDD",
    opacity: 0.5,
    strokeLinecap: "square",
    d: "M57 52.163H1"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#DDD",
    opacity: 0.3,
    x: 2.694,
    y: 85.709,
    width: 23.51,
    height: 14.694,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#DDD",
    opacity: 0.3,
    x: 32.571,
    y: 85.709,
    width: 23.51,
    height: 14.694,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#DDD",
    opacity: 0.3,
    x: 2.694,
    y: 54.607,
    width: 53.388,
    height: 14.694,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DDD",
    opacity: 0.5,
    strokeLinecap: "square",
    d: "M29.51 83.137v26.449"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#CCC",
    strokeLinecap: "square",
    d: "M57 14.5H1"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#DDD",
    fill: "#EEE",
    x: 4.5,
    y: 7.5,
    width: 49,
    height: 4.388,
    rx: 2.194
  }))));
}
export default SvgBannerPreview;